(function () {
  var DURATION_SEC = 10 * 60;
  var KEY = 'ft-cart-timer-end';
  var _interval = null;
  var _observer = null;

  function getOrSetEnd() {
    var stored = parseInt(localStorage.getItem(KEY), 10);
    if (!stored || stored < Date.now()) {
      stored = Date.now() + DURATION_SEC * 1000;
      localStorage.setItem(KEY, String(stored));
    }
    return stored;
  }

  function fmt(seconds) {
    if (seconds <= 0) return '00:00';
    var m = Math.floor(seconds / 60);
    var s = seconds % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function tick() {
    var el = document.getElementById('ft-cart-timer-countdown');
    if (!el) {
      clearInterval(_interval);
      _interval = null;
      return;
    }
    var end = parseInt(localStorage.getItem(KEY), 10) || 0;
    el.textContent = fmt(Math.max(0, Math.floor((end - Date.now()) / 1000)));
  }

  function startTimer() {
    var el = document.getElementById('ft-cart-timer-countdown');
    if (!el) return;
    getOrSetEnd();
    tick();
    clearInterval(_interval);
    _interval = setInterval(tick, 1000);
  }

  function observeMiniCart() {
    if (_observer) return;
    var root = document.getElementById('mini-cart');
    if (!root) return;
    _observer = new MutationObserver(function () {
      setTimeout(startTimer, 60);
    });
    _observer.observe(root, { childList: true });
  }

  document.addEventListener('cartdrawer:opened', startTimer);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeMiniCart);
  } else {
    observeMiniCart();
  }
})();
